/**
 * WELCHER ARBEITSBEREICH TRAEGT DIE BUEHNE?
 *
 * Eine Buehne nennt ihren Arbeitsbereich (`workspace`). Die Bühnenschicht wurde bis
 * 01.10.2026 NUR auf dem LayoutManager montiert, dessen Projekt genau so heisst. Fehlt
 * dieses Projekt im Haus — Partner-Buehnen aus `energy-entwicklung`, `heidecker-noise`,
 * `engelmann-dashboards` gibt es auf Dev nicht —, montierte niemand die Schicht, und der
 * Wechsel dorthin endete in einem `console.error`. Rafael sah dann das Standardlayout des
 * gerade offenen Arbeitsbereichs (Uploads, Tool Hub) statt der Entscheidungsseite:
 * *„warum gibt es da bühnen die nur upload zeigen? das html ist ja pflicht?"*
 *
 * Die Entscheidungsseite ist eine Browser-Kachel und haengt an keinem Arbeitsbereich.
 * Fehlt das Ziel, traegt sie deshalb der aktive — und `zielFehlt` sagt es laut, damit
 * der Guide den Grund zeigt, statt still etwas anderes anzuzeigen.
 */
export interface BuehnenWirt {
  /** Projekt, dessen LayoutManager die Bühnenschicht montiert; `null` = es gibt keins. */
  projectId: string | null;
  /** Der Arbeitsbereich der Bühne existiert in diesem Haus nicht. */
  zielFehlt: boolean;
}

export function buehnenWirt(ziel: string, vorhanden: readonly string[], aktiv: string | null | undefined): BuehnenWirt {
  if (vorhanden.includes(ziel)) return { projectId: ziel, zielFehlt: false };
  if (aktiv && vorhanden.includes(aktiv)) return { projectId: aktiv, zielFehlt: true };
  return { projectId: vorhanden[0] ?? null, zielFehlt: true };
}

/** Der Satz, den der Guide zeigt, wenn die Bühne über einem fremden Arbeitsbereich liegt. */
export function hinweisFehlenderArbeitsbereich(ziel: string): string {
  return `Den Arbeitsbereich „${ziel}" gibt es in diesem Haus nicht. Die Entscheidungsseite `
    + 'liegt deshalb über dem gerade offenen Arbeitsbereich; dessen Panels darunter gehören nicht zur Bühne.';
}
